import React from 'react'
import { useUser } from 'reactfire'
import { User } from 'firebase'

import useDispatchSelector from 'src/hooks/useDispatch'
import { Dispatch } from 'src/store'
import { updateTokens } from 'src/utils/client'

const dispatchSelector = ({
  user: { fetchLoggedInUser, setAuthResolved },
}: Dispatch) => ({
  fetchLoggedInUser,
  setAuthResolved,
})

export const useResolveAuth = () => {
  const user: User = useUser()
  const { fetchLoggedInUser, setAuthResolved } = useDispatchSelector(
    dispatchSelector
  )

  // resolve user auth
  React.useEffect(() => {
    const resolveLoggedInUser = async () => {
      if (user) {
        // refresh auth
        const tokenResponse = await user.getIdTokenResult(true)
        updateTokens({
          accessToken: tokenResponse.token,
          expiration: tokenResponse.expirationTime,
          refreshToken: user.refreshToken,
        })

        // eslint-disable-next-line no-undefined
        await fetchLoggedInUser(undefined)
      } else {
        setAuthResolved(true)
      }
    }
    resolveLoggedInUser()
  }, [fetchLoggedInUser, setAuthResolved, user])
}
